import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
  },
  // wrapper: {
  //   display: 'flex',
  //   flex: '1 1 auto',
  //   overflow: 'hidden',
  //   paddingTop: 64,
  //   [theme.breakpoints.up('lg')]: {
  //     paddingLeft: 256
  //   }
  // },
  // contentContainer: {
  //   display: 'flex',
  //   flex: '1 1 auto',
  //   overflow: 'hidden'
  // },
  content: {
    flex: '1 1 auto',
    overflow: 'auto',
    marginTop: '64px',
  },
  contentNoTopBar: {
    marginTop: 0,
  },
}))

export default useStyles
